<template lang="html">
    <div class="card card-statistics">
        <div class="card-body">
            <div class="clearfix">
                <div class="float-left">
                    <i class="mdi mdi-av-timer text-warning icon-lg"></i>
                </div>
                <div class="float-right">
                    <p class="card-text text-right">Waiting Time</p>
                    <div class="fluid-container">
                        <h3 class="card-title font-weight-bold text-right mb-0">{{ sliderWithLabel.value }} minutes</h3>
                    </div>
                </div>
            </div>
                <p class="text-muted mt-3">
                <i class="mdi mdi-bookmark-outline mr-1" aria-hidden="true"></i> 
                    <section class="range-label-slider">
                        <vue-slider v-model="sliderWithLabel.value"
                                    :lazy="true"
                                    :data="sliderWithLabel.data"
                                     :marks="sliderWithLabel.marks"
                                     :interval="15"
                                     @change="handleAdjustWaitingTime"
                                    />
                    </section>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'waitingtimecard',
    data () {
        return {
            sliderWithLabel: {
                value: 20,
                data: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60],
                marks: [5, 15, 30 , 45, 60],
                
            }
        }
    },

    methods : {
        async handleAdjustWaitingTime() {
            //
            //update current waiting time
            //
            
            await this.$store.dispatch('currentwaitingtime/updateCurrentWaitingTimeAction', this.sliderWithLabel.value)
        }
        
    }
  
}
</script>

<style scoped lang="scss">
.range-label-slider {
}
.vue-slide-bar-component {
  min-height: auto !important;
}
</style>